import React from 'react';

const Delivery = ({ rowData }) => {
    return (
        <span>
            {
                rowData.delivery_type === "l" ?
                    "تحویل از انبار" :
                rowData.delivery_type === "p" &&
                    "پست"
            }
        </span>
    );
}

export default Delivery;
